/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Link from 'components/Link/Link';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
// import Video from 'components/Video';
import Player from 'components/LitePlayer/Player';
import { setCookie, removeCookie } from 'utils/cookies';
import { debounce, inViewForReact, debugLogs } from 'utils/common';
import { TOI_IMAGE_DOMAIN } from '../../constants';
import {
  mute,
  setPlayerHeadless,
  pausePlayerForLw,
  resumePlayer,
} from '../Video/utils';
import s from './MiniTv.scss';
import CloseSticky from './CloseSticky/CloseSticky';

const tmplSrc = 'livetv';
class MiniTv extends React.PureComponent {
  constructor(props) {
    super(props);
    const showWebMiniTv = this.checkShowWebMiniTv(props);
    const { miniTvData, isWapView, mwebfullview } = props || {};
    const { loadstate } = miniTvData || {};
    let webVerticalCls = isWapView || loadstate !== 'expanded';
    if (mwebfullview) {
      webVerticalCls = false;
    }
    this.state = {
      defaultPosition: { x: -50, y: -56 },
      hideClsOnscroll: false,
      expandedBox: false,
      showOverlayBtns: false,
      uiReady: false,
      showWebMiniTv,
      webVerticalCls,
      startTimer: false,
      userClickedExpanded: false,
      isDock: false,
    };
    this.conEl = `minitv`;
    this.debouncedHandleScroll = null;
    this.portrait = null;
    this.observer = null;
    this.isInView = false;
  }

  getPlayerRef = () => {
    const targetRef = this.props.containerRef;
    return targetRef?.current;
  };

  checkShowWebMiniTv = props => {
    try {
      const { pageType, miniTvData, isWapView, isInPageDock } = props;
      if (isWapView || isInPageDock) return false;
      const { loadevent, rosloadevent } = miniTvData;
      const onloadEvs = ['onloadexpand', 'onload'];
      if (pageType === 'Home' || pageType === 'HomeUs') {
        return onloadEvs.includes(loadevent);
      }
      return onloadEvs.includes(rosloadevent);
    } catch (error) {
      return true;
    }
  };

  closeDocking = () => {
    const targetRef = this.getPlayerRef();
    if (targetRef && this.observer) {
      this.setState({ isDock: false });
      this.observer.unobserve(targetRef);
      this.observer.disconnect();
    }
  };

  componentDidUpdate(prevProps) {
    if (
      !this.props.isWapView &&
      prevProps.isETimesNudgeVisible !== this.props.isETimesNudgeVisible
    ) {
      const defaultPosition = {
        x: this.state.defaultPosition.x,
        y: this.props.isETimesNudgeVisible ? -101 : -56,
      };
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ defaultPosition });
    }
  }

  setGaEventMiniTv = (action, label, skiplong, ...args) => {
    const { miniTvData, isWapView } = this.props;
    const category = !isWapView ? 'minitv_web' : 'minitv_wap';
    const newlabel = skiplong
      ? label
      : `${label}_${miniTvData.videoId}_${miniTvData.hl}_${
          window.categoryForGA
        }`;
    analyticsWrapper(
      'grx',
      'send',
      'event',
      category,
      action,
      newlabel,
      ...args,
    );
  };
  observerInDock = () => {
    const { miniTvData } = this.props;
    const threshold = miniTvData?.threshold || [0.5, 0];

    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
      threshold, // trigger when 50% of the target is visible
    };
    const ref = this.getPlayerRef();
    if (!ref) {
      return;
    }
    const callback = entries => {
      entries.forEach(entry => {
        const isOutofViewDownside =
          entry.boundingClientRect.top < entry.intersectionRect.top;
        const view = entry.isIntersecting;

        const notInview = !view && isOutofViewDownside;
        const obj = { isDock: notInview };
        this.setState(obj);
      });
    };
    this.observer = new IntersectionObserver(callback, options);
    this.observer.observe(ref);
  };

  componentDidMount() {
    const { miniTvData, isWapView, pageType, isInPageDock } = this.props;
    const { loadevent, rosloadevent, sticky } = miniTvData;

    if (!isWapView && !isInPageDock) {
      if (pageType === 'Home' || pageType === 'HomeUs') {
        this.processLoadEventForDesktop(loadevent, miniTvData, pageType, 10);
      } else {
        this.processLoadEventForDesktop(rosloadevent, miniTvData, pageType);
      }
    } else {
      this.setGaEventMiniTv('view', `minitv_view`, {
        nonInteraction: 1,
      });
    }
    if (sticky && isWapView && isInPageDock) {
      this.observerInDock();
    } else if (!isWapView && isInPageDock) {
      this.observerInDock();
    }

    if (window.location.href.indexOf('test=2') === -1) {
      this.setState({ uiReady: true });
      this.props.uiReady(true);
    }
  }

  processLoadEventForDesktop = (loadevent, miniTvData, pageType, tm) => {
    try {
      const { loadeventVal } = miniTvData;
      let timeoutVal = 10;
      if (!tm && loadeventVal > 0) {
        timeoutVal = loadeventVal;
      }
      switch (loadevent) {
        case 'timeout':
          setTimeout(() => {
            this.setState({ showWebMiniTv: true });
            this.setGaEventMiniTv('view', `minitv_view`, 0, {
              nonInteraction: 1,
            });
          }, timeoutVal * 1000);
          break;
        case 'onscroll':
          if (pageType === 'Home' || pageType === 'HomeUs') {
            this.getKeywordsPos();
            this.debouncedHandleScroll = debounce(this.handleScroll, 10);
          } else {
            this.debouncedHandleScroll = debounce(
              () => this.handleScrollRos(),
              10,
            );
          }
          window.addEventListener('scroll', this.debouncedHandleScroll);
          this.setState({ hideClsOnscroll: true });
          this.setGaEventMiniTv('view', `minitv_view`, 0, {
            nonInteraction: 1,
          });
          break;
        case 'onloadexpand':
          this.debouncedHandleScroll = debounce(
            () => this.expandOnScrollRos(),
            10,
          );

          window.addEventListener('scroll', this.debouncedHandleScroll);
          break;
        default:
          this.setGaEventMiniTv('view', `minitv_view`, 0, {
            nonInteraction: 1,
          });
      }
    } catch (error) {
      //
    }
  };

  componentWillUnmount() {
    if (this.debouncedHandleScroll)
      window.removeEventListener('scroll', this.debouncedHandleScroll);

    this.closeDocking();
  }
  updateWebVerticalClass(isunMute) {
    if (this.state.webVerticalCls) {
      this.setState({ webVerticalCls: false });
      if (!isunMute) {
        mute(false, this.conEl);
      }
      setPlayerHeadless(false, this.conEl);
    }
  }

  collapseExpandRosOnScrollBack() {
    this.setState({ webVerticalCls: true });
    mute(true, this.conEl);
    setPlayerHeadless(true, this.conEl);
  }

  processVideoEvent(args, web) {
    try {
      const { miniTvData } = this.props;
      const event = args && args[0];
      let state;
      switch (event) {
        case 'VIDEOCOMPLETE':
          if (web && miniTvData?.videoInloop !== '1') {
            this.props.showMiniTvPlayer(false);
            this.lastScrollTop = 0;
          }
          break;
        case 'ADSTART':
          state = { showOverlayBtns: false, startTimer: true };
          break;
        case 'ADCOMPLETE':
          state = { showOverlayBtns: true };
          break;
        case 'VIDEOVIEW':
          state = { showOverlayBtns: true, startTimer: true };
          break;
        case 'ADSKIP':
          state = { showOverlayBtns: true };
          break;
        case 'VIDEOINIT':
        case 'INIT':
          debugLogs('===> mini TV started', performance.now() / 1000);
          state = { showOverlayBtns: true };
          break;
        default:
      }
      if (state) this.setState(state);
    } catch (error) {
      //
    }
  }
  getAdSectionName = () => {
    const adSec = `${tmplSrc}_`;
    if (window?.Times?.adsKeys?.Tmpl_SCN === 'home') {
      return `${adSec}hp`;
    }
    return `${adSec}across`;
  };
  renderVideoPlayer = isweb => {
    const {
      isUserPrime,
      miniTvData,
      isVideotagEnable,
      isInPageDock,
    } = this.props;
    const { isDock } = this.state;
    const { updateConfig } = miniTvData || {};

    const tmplSource = miniTvData.tmplSource || tmplSrc;
    let container = `${s.minitvplayer} `;
    if (!isDock) {
      container += ` globalMinitvPlayer`;
    }
    if (!isweb && isInPageDock && !isDock) {
      container += ` ${s.in_page}`;
    }
    const slikePlayerConfig = {
      autoplay: true,
      videoClassName: container,
      videoClassInner: s.player_container_bg,
      slikeId: miniTvData.videoId,
      livetv: true,
      msid: miniTvData.imageid,
      playerContainerId: 'player-livetv',
      isPrime: false,
      allowDim: false,
      isUserPrime,
      isVideoSkipAds: miniTvData.skipAds === '1',
      videoInloop: miniTvData.videoInloop === '1',
      outsideEventListener: (...args) => {
        this.processVideoEvent(args, isweb);
      },
      isMute: true,
      sectionName: miniTvData.sectionName,
      source: 'MINI_TV',
      agency: miniTvData.agency || 'customMiniTv',
      titleStr: miniTvData.hl,
      shareUrl: miniTvData.shareUrl,
      headless: this.state.webVerticalCls,
      tplId: tmplSource,
      metakeywords: miniTvData.metakeywords,
      bl: miniTvData.bl,
      midfreq: miniTvData.midfreq,
      splId: miniTvData.splId,
    };
    if (!isVideotagEnable) return <div className={container} />;
    const liteConfig = {
      ...slikePlayerConfig,
      divId: `minitv_player_id${miniTvData.imageid}`,
      globalRefId: this.conEl,
      config: updateConfig,
      newGamAdSection: this.getAdSectionName(),
    };
    return <Player {...liteConfig} />;
  };

  renderCloseWebBtn = () => {
    const { showMiniTvPlayer, isInPageDock } = this.props;
    const { isDock } = this.state;
    if (isInPageDock && !isDock) {
      return null;
    }
    return (
      <button
        className={s.closelivetv}
        type="button"
        onClick={e => {
          mute(true, this.conEl);
          this.setGaEventMiniTv('click', `minitv_close`);
          this.lastScrollTop = 0;
          e.stopPropagation();
          if (isInPageDock && this.observer) {
            this.closeDocking();
          } else {
            setCookie('minitvClose', 1, 1, '/', '.indiatimes.com');
            showMiniTvPlayer(false);
          }
        }}
      />
    );
  };

  desktopMiniTV = () => {
    const { miniTvData, isInPageDock } = this.props;
    const playerWrapperClass = classNames({
      [s.webcontainer]: true,
      [`${s.reactDraggable}`]: this.state.isDock,
      [s.minitv_dock_wrapper_cs]: isInPageDock,
      [`${s.hideWebMiniTv}`]: this.state.hideClsOnscroll,
    });
    const sponsorshipConfig = this.isSponserActive();
    const isDescEnabled = miniTvData.marker || miniTvData.hl;
    const descWrapper = classNames({
      [s.livetv_head]: isDescEnabled,
    });
    return (
      <div className={playerWrapperClass}>
        <div
          className={classNames({
            [`${s.shiftUp}`]: this.props.isPopupVisible,
            [`${s.shiftRight}`]: this.state.webVerticalCls,
          })}
          onClick={e => {
            if (this.state.showOverlayBtns) {
              this.updateWebVerticalClass();
            }
            e.stopPropagation();
          }}
        >
          {this.renderCloseWebBtn()}
          {this.renderVideoPlayer(true)}
          {this.renderOverlayBtn(!this.state.webVerticalCls)}
          <div
            className={descWrapper}
            onClick={() => {
              this.updateWebVerticalClass();
              this.setState({ userClickedExpanded: true });
              this.setGaEventMiniTv('click', 'minitv_expand');
            }}
          >
            {isDescEnabled && (
              <div>
                <Link
                  target="_blank"
                  to={miniTvData.shareUrl}
                  forceTargetBlank
                  className={s.webdescinner}
                >
                  {miniTvData.marker && (
                    <h6 className={s.headingTxt}>{miniTvData.marker}</h6>
                  )}
                  {miniTvData.hl && (
                    <span
                      className={
                        sponsorshipConfig
                          ? ''
                          : `${s.lineClamp} globalMinitvDesc`
                      }
                    >
                      {miniTvData.hl}
                    </span>
                  )}
                </Link>
              </div>
            )}

            {sponsorshipConfig && this.renderBottomLogo(sponsorshipConfig)}
          </div>
        </div>
      </div>
    );
  };

  renderDesktopMiniTvPlayer() {
    const { isInPageDock } = this.props;
    if (isInPageDock) {
      return this.desktopMiniTV();
    }

    if (this.state.showWebMiniTv) {
      return (
        <Draggable
          axis="both"
          bounds={false}
          allowAnyClick={false}
          cancel={null}
          disabled={false}
          scale={1}
          defaultClassName={`${s.reactDraggable} ${s.shift}`}
          defaultPosition={{ x: -50, y: -56 }}
          position={this.state.defaultPosition}
        >
          {this.desktopMiniTV()}
        </Draggable>
      );
    }
    return null;
  }

  // TOIPR-64295 : Sponsor Logo Integration
  renderBottomLogo = sponsorshipConfig => {
    const { imageid, link, text, imagewidth } = sponsorshipConfig || {};
    const msid = imageid;
    const w = imagewidth || 60;
    const src = `${TOI_IMAGE_DOMAIN}/thumb/msid-${msid},width-${w},resizemode-4/${msid}.jpg`;
    return (
      <div className={s.tv_powered_by}>
        <Link
          target="_blank"
          to={link}
          onClick={e => {
            this.setGaEventMiniTv('click', 'minitv_icon', 1);
            e.stopPropagation();
          }}
        >
          {text && <h6>{text}</h6>}
          <img src={src} alt="logo" className={s.sponserImg} />
        </Link>
      </div>
    );
  };

  renderDesktopBanner() {
    const {
      miniTvData,
      showMiniTvPlayer,
      closeVideoTheatre,
      overRideClass,
    } = this.props;
    const livetvbanner =
      window?.Times?.adsKeys?.Tmpl_SCN === 'home' ? s.home : '';
    const event = new Event('custom_Zodaic_event');
    return (
      <div className={` ${s.livetv_banner} ${overRideClass} ${livetvbanner}`}>
        <button
          type="button"
          onClick={() => {
            this.props.closeMiniTvWidget();
            this.setGaEventMiniTv('click', 'minitv_banner_close');
            window.dispatchEvent(event);
          }}
        />
        <div
          className={s.text}
          onClick={() => {
            removeCookie('minitvClose', '/', '.indiatimes.com');
            closeVideoTheatre();
            this.scrollToPos();
            this.updateWebVerticalClass();
            showMiniTvPlayer(true);
            this.setGaEventMiniTv('click', 'minitv_reopen');
          }}
        >
          {miniTvData.marker && <span>{miniTvData.marker}</span>}
          {miniTvData.hl && <h3>{miniTvData.hl}</h3>}
        </div>
      </div>
    );
  }
  scrollToPos() {
    try {
      const { miniTvData, pageType } = this.props;
      const isHP = pageType === 'Home' || pageType === 'HomeUs';
      if (miniTvData?.loadevent === 'onscroll' && isHP) {
        const ypos = this.webScrollpos || this.getKeywordsPos();
        if (ypos) {
          window.scrollTo({
            top: ypos + 1,
            behavior: 'smooth',
          });
        }
      }
      if (
        miniTvData?.rosloadevent === 'onscroll' &&
        miniTvData?.loadeventVal > 0 &&
        !isHP
      ) {
        window.scrollTo({
          top: +miniTvData.loadeventVal + 1,
          behavior: 'smooth',
        });
      }
    } catch (error) {
      //
    }
  }

  checkScrollDirection = () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    let upScroll = true;
    if (st > this.lastScrollTop) {
      upScroll = false;
    }
    this.lastScrollTop = st <= 0 ? 0 : st;
    return upScroll;
  };
  hideplayer = () => {
    if (!this.state.hideClsOnscroll) {
      this.setState(
        {
          hideClsOnscroll: true,
        },
        () => {
          pausePlayerForLw(this.conEl);
        },
      );
    }
  };

  showplayer = () => {
    if (this.state.hideClsOnscroll) {
      this.setState(
        {
          hideClsOnscroll: false,
          showWebMiniTv: true,
        },
        () => {
          resumePlayer(this.conEl);
          mute(true, this.conEl);
        },
      );
    }
  };

  handleScrollRos = () => {
    try {
      const { isMiniTvPlayerShown, miniTvData } = this.props;
      const { loadeventVal } = miniTvData;
      if (!isMiniTvPlayerShown || !loadeventVal) {
        return;
      }
      const upScroll = this.checkScrollDirection();
      if (!upScroll && window.pageYOffset >= loadeventVal) {
        this.showplayer();
      } else if (upScroll && window.pageYOffset < loadeventVal) {
        this.hideplayer();
      }
    } catch (error) {
      //
    }
  };

  expandOnScrollRos = () => {
    try {
      const { isMiniTvPlayerShown, miniTvData } = this.props;
      const { loadeventVal } = miniTvData;
      if (!isMiniTvPlayerShown || !loadeventVal) {
        return;
      }
      if (window.pageYOffset >= loadeventVal) {
        this.updateWebVerticalClass(true);
      } else if (!this.state.userClickedExpanded) {
        this.collapseExpandRosOnScrollBack();
      }
    } catch (error) {
      //
    }
  };

  onCloseStickyWidget = () => {
    try {
      window.Times.minitvmwebClose = true;
      this.props.closeMiniTvWidget(true);
      setCookie('minitvmwebClose', 'y', 1, '/');
      // eslint-disable-next-line camelcase
      const { Channel, Tmpl_SCN: tmpl } = window.Times.adsKeys || {};
      const category = `miniTV_mweb_${Channel}`;
      const action = `Close_miniTV_mweb`;
      const label = `${tmpl}_LP_${window.location.href}_VidURL_${
        this.props.miniTvData.shareUrl
      }`;
      analyticsWrapper('gaAndGrx', 'send', 'event', category, action, label);
    } catch (error) {
      //
    }
  };

  getKeywordsPos = () => {
    try {
      const elem = document.getElementById('keywords');
      const elementPosition =
        elem && elem.getBoundingClientRect().bottom + window.pageYOffset;

      if (!this.webScrollpos) {
        this.webScrollpos = elementPosition;
      }
      return this.webScrollpos || 0;
    } catch (error) {
      return 0;
    }
  };

  handleScroll = () => {
    try {
      const { miniTvData, isMiniTvPlayerShown } = this.props;
      if (miniTvData && isMiniTvPlayerShown) {
        const elem = document.getElementById('keywords');
        const isInView = inViewForReact(elem);
        const upScroll = this.checkScrollDirection();
        if (
          (!upScroll && isInView) ||
          window.pageYOffset >= Math.round(this.webScrollpos)
        ) {
          this.showplayer();
        } else if (window.pageYOffset < Math.round(this.webScrollpos)) {
          this.hideplayer();
        }
      }
    } catch (error) {
      //
    }
  };

  resetPlayerHeight = () => {
    try {
      const minitvplayer = document.getElementsByClassName(s.minitvplayer)[0];
      let height = '';
      if (this.state.expandedBox) {
        height = this.portrait?.matches
          ? `${window.innerHeight - 30}px`
          : `${window.innerWidth * 9 / 16}px`;
      }
      minitvplayer.style.height = height;
    } catch (error) {
      //
    }
  };
  onOrientationChange = () => {
    this.resetPlayerHeight();
  };
  attachOrientation = () => {
    try {
      this.portrait = window.matchMedia('(orientation: landscape)');
      this.portrait.addEventListener('change', this.onOrientationChange);
    } catch (error) {
      //
    }
  };

  removeOrientation = () => {
    try {
      if (this.portrait)
        this.portrait.removeEventListener('change', this.onOrientationChange);
    } catch (error) {
      //
    }
  };

  toggleTheVideoBox = () => {
    this.setState(
      prevState => ({ expandedBox: !prevState.expandedBox }),
      () => {
        if (this.props.isWapView) {
          if (this.state.expandedBox) {
            setPlayerHeadless(false, this.conEl);
            mute(false, this.conEl);
            const { miniTvData = {} } = this.props;
            analyticsWrapper(
              'grx',
              'send',
              'event',
              'minitv_wap',
              'click',
              `minitv_expand_${miniTvData.videoId}_${window.categoryForGA ||
                ''}`,
            );
            this.attachOrientation();
          } else {
            setPlayerHeadless(true, this.conEl);
            mute(true, this.conEl);
            this.removeOrientation();
          }
          this.resetPlayerHeight();
        }
      },
    );
  };

  mwebBannerClick = () => {
    const { miniTvData = {}, isWapView } = this.props;
    const { shareUrl, redirectionType } = miniTvData;
    if (redirectionType === 'popup' && isWapView) {
      this.toggleTheVideoBox();
    } else {
      window.open(shareUrl, '_blank');
    }
  };

  renderOverlayBtn = expandedBox =>
    !expandedBox &&
    this.state.showOverlayBtns && (
      <div className={`${s.mute_expand_btns}`}>
        <span className={s.mute_btn} />
        {/* <span className={s.expand_btn} /> */}
      </div>
    );

  checkTmplCondition = (isWapView, condition) => {
    // mwebhome_ussecsub
    try {
      const { isInPageDock } = this.props;
      const inpage = isInPageDock ? 'inpage' : '';
      const conditions = Array.isArray(condition) ? condition : [condition];
      const p = isWapView ? 'mweb' : 'web';
      const { SCN = '', SubSCN = '', Tmpl_SCN = '' } = window.Times.adsKeys;
      const cond = inpage + p + Tmpl_SCN + SubSCN + SCN;
      return conditions.includes(cond);
    } catch (error) {
      return false;
    }
  };

  isSponserActive = () => {
    const { miniTvData = {}, isWapView } = this.props;

    if (miniTvData?.sponsorshipConfig?.condition?.length) {
      const isActive = this.checkTmplCondition(
        isWapView,
        miniTvData.sponsorshipConfig.condition,
      );
      return isActive ? miniTvData?.sponsorshipConfig : null;
    }
    return miniTvData.sponsorshipConfig;
  };

  renderMobileMiniTvPlayerWithBanner() {
    const { miniTvData = {}, isInPageDock, minitvMwebInPage } = this.props;
    const { shareUrl, bottomCta = {} } = miniTvData;
    const styleObject = this.props.styleObject || s;
    const { expandedBox, uiReady, isDock } = this.state;
    const unDock = isInPageDock && !isDock;
    let minitvView = '';
    if (minitvMwebInPage && !isDock) {
      minitvView = s.largeview;
    }
    if (minitvMwebInPage && isDock) {
      minitvView = s.smallview;
    }

    const containerClasses = classNames({
      [s.overlay]: expandedBox,
      [`${styleObject.minitv} ${s.collapsedMinitv}`]: !expandedBox,
      [s.hideminitv]: !uiReady,
      [s.inpage_undock_player]: unDock,
      [minitvView]: minitvView,
    });

    const closeBtnClasses = classNames({
      [s.close_btn]: expandedBox,
      [`${styleObject.minitv_close} ${s.close_btn}`]: !expandedBox,
    });
    const closeTimer = classNames({
      [s.close_timer_hide]: expandedBox || unDock,
    });

    const sponsorshipConfig = this.isSponserActive();
    const descriptionWrapper = classNames({
      [s.tv_powered_by_container]: sponsorshipConfig,
      [s.dock_desc]: isDock,
    });
    const bottomCtaConfig = {
      active: bottomCta.forAll || minitvMwebInPage,
      url: bottomCta.url || shareUrl,
      text: bottomCta.text || 'Watch',
      target: bottomCta.target || '_blank',
    };
    const isDescEnabled = miniTvData.marker || miniTvData.hl;
    const descWrapper = classNames({
      [s.desc_block]: isDescEnabled,
    });

    return (
      <>
        <div className={containerClasses}>
          <div
            className={`${s.minitvInnerContainer} ${
              styleObject.minitvInnerContainer
            }`}
          >
            {expandedBox && (
              <button
                type="button"
                className={closeBtnClasses}
                onClick={() => {
                  if (expandedBox) {
                    this.mwebBannerClick();
                  } else {
                    analyticsWrapper(
                      'grx',
                      'send',
                      'event',
                      'minitv_wap',
                      'click',
                      `minitv_close_${
                        miniTvData.videoId
                      }_${window.categoryForGA || ''}`,
                    );
                    this.props.closeMiniTvWidget();
                  }
                }}
              >
                Close
              </button>
            )}
            {this.state.startTimer &&
              miniTvData?.sticky && (
                <div className={closeTimer}>
                  <CloseSticky
                    timeout={miniTvData.closeTimeout}
                    closeMiniTvWidget={() => {
                      this.onCloseStickyWidget();
                    }}
                  />
                </div>
              )}
            <div className={`${s.minitv_txt} ${styleObject.minitv_txt}`}>
              <div
                className={s.promowrapper}
                onClick={e => {
                  if (!expandedBox && this.state.showOverlayBtns) {
                    this.mwebBannerClick();
                  }
                  e.stopPropagation();
                }}
              >
                {this.renderVideoPlayer()}
                {this.renderOverlayBtn(expandedBox)}
              </div>
              <div
                onClick={() => {
                  if (!expandedBox) {
                    this.mwebBannerClick();
                  }
                }}
                className={descriptionWrapper}
              >
                <div className={descWrapper}>
                  {miniTvData.marker && (
                    <h2 className={`${s.blinker} ${styleObject.blinker}`}>
                      {miniTvData.marker}
                    </h2>
                  )}
                  {miniTvData.hl && (
                    <h3
                      className={
                        sponsorshipConfig
                          ? ''
                          : `${s.lineClamp} globalMinitvDesc`
                      }
                    >
                      {miniTvData.hl}
                    </h3>
                  )}

                  {bottomCtaConfig.active && (
                    <Link
                      target={bottomCtaConfig.target}
                      to={bottomCtaConfig.url}
                      className={s.watchBtn}
                      forceTargetBlank
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    >
                      {bottomCtaConfig.text}
                      <i />
                    </Link>
                  )}
                </div>
                {!expandedBox &&
                  sponsorshipConfig &&
                  this.renderBottomLogo(sponsorshipConfig)}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  render() {
    const {
      isWapView,
      isMiniTvPlayerShown,
      miniTvData,
      isInPageDock,
    } = this.props;
    if (!miniTvData) {
      return null;
    }
    if (isMiniTvPlayerShown) {
      return isWapView
        ? this.renderMobileMiniTvPlayerWithBanner()
        : this.renderDesktopMiniTvPlayer();
    }
    if (isInPageDock) {
      return this.desktopMiniTV();
    }
    return isWapView ? null : this.renderDesktopBanner();
  }
}

const mapStateToProps = state => ({
  isPopupVisible: state.WithPopup && state.WithPopup.isVisible,
  isVideotagEnable: state.miniTv?.videoEnable,
  minitvPlayerType: state?.revenue?.data?.widgets?.minitvType,
});

MiniTv.propTypes = {
  miniTvData: PropTypes.shape({
    loadevent: PropTypes.string,
    rosloadevent: PropTypes.string,
    sectionName: PropTypes.string,
    loadeventVal: PropTypes.number,
    imageid: PropTypes.string,
    marker: PropTypes.string,
    hl: PropTypes.string,
    sponsorshipConfig: PropTypes.shape({}),
    skipAds: PropTypes.string,
    videoInloop: PropTypes.string,
    videoId: PropTypes.string,
    agency: PropTypes.string,
    shareUrl: PropTypes.string,
    config: PropTypes.shape({
      player: PropTypes.shape({}),
    }),
    midfreq: PropTypes.arrayOf(PropTypes.number),
    metakeywords: PropTypes.string,
    bl: PropTypes.string,
    tmplSource: PropTypes.string,
    splId: PropTypes.string,
  }).isRequired,
  mwebfullview: PropTypes.bool,
  isVideotagEnable: PropTypes.bool,
  closeMiniTvWidget: PropTypes.func.isRequired,
  isWapView: PropTypes.bool.isRequired,
  showMiniTvPlayer: PropTypes.func.isRequired,
  isMiniTvPlayerShown: PropTypes.bool.isRequired,
  closeVideoTheatre: PropTypes.func,
  isUserPrime: PropTypes.bool,
  styleObject: PropTypes.shape({}),
  isPopupVisible: PropTypes.bool,
  overRideClass: PropTypes.string,
  pageType: PropTypes.string,
  isInPageDock: PropTypes.bool,
  minitvPlayerType: PropTypes.string,
};
MiniTv.defaultProps = {
  isUserPrime: false,
  closeVideoTheatre: undefined,
  styleObject: undefined,
  isPopupVisible: false,
  overRideClass: '',
  pageType: '',
  isVideotagEnable: false,
  isInPageDock: false,
  mwebfullview: false,
  minitvPlayerType: '',
};
export default connect(mapStateToProps)(MiniTv);
